export enum RouteType {
  Unknown = 0,
  SoloDedicated = 1,
  SoloUnassigned = 2,
  SoloSpare = 3,
  TeamDedicated = 4,
  TeamUnassigned = 5,
  TeamSpare = 6,
  Administrative = 7,
  NonDriving = 8,
  SoloDedicatedTemp = 9,
  TeamDedicatedTemp = 10
}

export const RouteTypeMapping: Record<RouteType, string> = {
  [RouteType.Unknown]: 'Unknown',
  [RouteType.SoloDedicated]: 'Dedicated Solo',
  [RouteType.SoloUnassigned]: 'Unassigned Solo',
  [RouteType.SoloSpare]: 'Spare Solo',
  [RouteType.TeamDedicated]: 'Dedicated Team',
  [RouteType.TeamUnassigned]: 'Unassigned Team',
  [RouteType.TeamSpare]: 'Spare Team',
  [RouteType.Administrative]: 'Reporting Purposes',
  [RouteType.NonDriving]: 'Non-Driving',
  [RouteType.SoloDedicatedTemp]: 'Solo Dedicated (Temp)',
  [RouteType.TeamDedicatedTemp]: 'Team Dedicated (Temp)'
};

export const TeamRouteTypes: RouteType[] = [
  RouteType.Administrative,
  RouteType.TeamDedicated,
  RouteType.TeamSpare,
  RouteType.TeamUnassigned,
  RouteType.TeamDedicatedTemp,
  RouteType.Unknown
];
